import React, {useMemo} from 'react';

import {Link, Typography, PropTypes} from '@material-ui/core';

import useStyles from './styles';

interface CopyrightProps {
  color?: string
  align?: PropTypes.Alignment
}

const Copyright = (props: CopyrightProps) => {
  const classes = useStyles();

  const styles = useMemo(() => ({color: props.color}), [props.color]);

  return (
    <Typography className={classes.copyright} variant="body2" align={props.align} style={styles}>
      <Link color="inherit" href="https://manabie.vn/">
        Manabie
      </Link>
      {' © '}
      2020
    </Typography>
  );
};

Copyright.defaultProps = {
  align: 'center'
};

export default Copyright